import { render, staticRenderFns } from "./FieldType19.vue?vue&type=template&id=1062c73a&scoped=true"
import script from "./FieldType19.vue?vue&type=script&lang=js"
export * from "./FieldType19.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1062c73a",
  null
  
)

export default component.exports